import classNames from 'classnames';
import * as React from 'react';
import Icon from '../Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from '~/mobx/localesStore';
import CustomTooltip, { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import './style.scss';

export interface IInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  error?: boolean;
  editable?: boolean;
  showTooltip?: boolean;
  tooltipText?: string;
  wrapperClassName?: string;
  errorMessage?: string;
  // WARNING !!! resetIcon won't work unless use onChangeText
  withResetIcon?: boolean;
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeText?: (text: string) => void;
  /**
   * Reset input value
   *
   * @memberof IInputProps
   */
  onReset?: () => void;
}

/**
 * deprecated input component. Please do not use it !!!
 */
export default class Input extends React.Component<IInputProps, {}> {
  static defaultProps = {
    editable: true,
    wrapperClassName: '',
  };

  onClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    if (!this.props.onClick || this.props.disabled) {
      return;
    }
    this.props.onClick(event);
  };

  /**
   * Reset Input value
   *
   * Call onReset from props if it's exist and change text to ''
   *
   * @memberof Input
   */
  onReset = () => {
    if (this.props.onReset) this.props.onReset();
    this.handleTextChanged(true);
  };

  handleTextChanged = (data: React.ChangeEvent<HTMLInputElement> | boolean) => {
    const textValue: string = typeof data === 'boolean' ? '' : data.target.value;
    if (this.props.onChangeText) {
      this.props.onChangeText(textValue);
    } else if (this.props.onChange && typeof data !== 'boolean') {
      this.props.onChange(data);
    }
  };

  get textValue(): string | number | readonly string[] | undefined {
    if (this.props.value !== undefined) return this.props.value;
    if (this.props.defaultValue !== undefined) return this.props.defaultValue;
    return this.props.withResetIcon ? '' : undefined;
  }

  public render() {
    const {
      className,
      showTooltip,
      tooltipText,
      wrapperClassName,
      error,
      errorMessage,
      // eslint-disable-next-line unused-imports/no-unused-vars
      onClick,
      children,
      editable,
      withResetIcon,
      value,
      defaultValue,
      // eslint-disable-next-line unused-imports/no-unused-vars
      onChange,
      // eslint-disable-next-line unused-imports/no-unused-vars
      onChangeText,
      ...props
    } = this.props;

    return (
      <div className={classNames('d-flex input-wrapper', wrapperClassName)}>
        <div onClick={this.onClick} className={`d-flex `}>
          <input
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            onChange={this.handleTextChanged}
            value={this.textValue}
            className={classNames('input', className, { 'input-error': error })}
          />

          {showTooltip ? (
            <CustomTooltip
              position={TOOLTIP_POSITION.ABSOLUTE}
              message={localeStore.t(tooltipText ?? '')}
              wrapperClassName="input-info"
              minWidth={350}
              messageClassName="text-danger"
            >
              <Icon name={Icons.Info} className="cursor-pointer color-red" size={16} />
            </CustomTooltip>
          ) : null}

          {withResetIcon && (value || defaultValue) ? (
            <div className="input-close" onClick={this.onReset}>
              <Icon name={Icons.CloseSmall} size={16} color={theme.colors.gray2} className="my-auto" />
            </div>
          ) : null}

          {!editable ? <div className="input-noteditable"></div> : ''}
          {children}
        </div>
        {error && errorMessage ? <div className="input-error-message">{errorMessage}</div> : null}
      </div>
    );
  }
}
